import * as Sentry from '@sentry/browser';
import config from '../config';

export default function captureError(error: Error, errorInfo?: any) {
  if (config.sentry && config.sentry.dsn) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }

  if (config.logErrorsToConsole) {
    console.group(error.message);
    console.error(error);
    console.error(errorInfo);
    console.groupEnd();
  }
}
